export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/product/addProductComposition',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['productbyid']       
    })
